import { DepositInvoiceAmountType } from '../../../enums/depositInvoiceAmountType'
import { DepositInvoiceConfig } from '../../../types/invoiceDeposit/depositInvoiceConfig'

export const getDepositInvoiceDetailsFormDefaultValues = (predefinedValues?: DepositInvoiceConfig) => {
  return {
    amount: predefinedValues?.amount || undefined,
    type: predefinedValues?.type || DepositInvoiceAmountType.Percentage,
  }
}
